const colors = {
  white: '#fff',
  black: '#000',
  gray: '#e8e8e8',
  darkGray: '#b2b2b2',
  lightGray: '#f4f4f4',
  navGray: '#1e1e1e',
  pink: '#D324AC',
  /* lab colors */
  greenOne: '#44B49F',
  greenTwo: '#77C0A2',
  greenThree: '#9BCCA4',
  greenFour: '#BEDAA7',
  greenFive: '#C9D19D',
  blue: '#0089A7',
  purple: '#B2779A',
  red: '#ED6976',
  orange: '#F5A578',
  yellow: '#FFD664',
  /* mein-futurium colors  */
  mfDarkBlue: '#409CFD',
  mfBlue: '#6FC3F6',
  mfDarkGrey: '#f03874',
  mfGrey: '#B61F52',
  mfDarkGreen: '#188766',
  mfGreen: '#35AB88',
  /* teaser colors */
  teaserPink: '#ef3874',
  teaserGray: '#76797D',
  berry: '#F03874'
};

// Breakpoints
const breakpoints = {
  xs: '375px',
  s: '480px',
  m: '768px',
  l: '940px',
  xl: '1280px',
  xxl: '1540px'
};

// Spacings
const spacings = {
  xxxxs: '5px',
  xxxs: '10px',
  xxs: '15px',
  xs: '20px',
  s: '24px',
  m: '30px',
  l: '40px',
  xl: '60px',
  xxl: '70px',
  xxxl: '90px'
};

// Grid
const maxWidth = '1120px';
const grid = {
  columns: 12,
  gutters: 10,
  debugColors: 'hsla(100, 100%, 50%, 0.2)'
};

// Fonts
const fontFamilies = {
  default: 'Futurium Type, Helvetica, sans-serif',
  international: 'NB International Pro, Helvetica, sans-serif'
};

const textTypes = {
  big: {
    fontWeight: 400,
    lineHeight: '66px',
    fontSize: '66px',
    m: {
      lineHeight: '80px',
      fontSize: '80px'
    }
  },
  primary: {
    fontWeight: 400,
    lineHeight: '40px',
    fontSize: '40px',
    m: {
      lineHeight: '54px',
      fontSize: '50px'
    }
  },
  secondary: {
    fontWeight: 400,
    lineHeight: '32px',
    fontSize: '30px',
    m: {
      lineHeight: '40px',
      fontSize: '36px'
    }
  },
  tertiary: {
    fontWeight: 400,
    lineHeight: '22px',
    fontSize: '20px',
    m: {
      lineHeight: '30px',
      fontSize: '26px'
    }
  },
  teaser: {
    fontWeight: 400,
    lineHeight: '32px',
    fontSize: '30px',
    l: {
      lineHeight: '40px',
      fontSize: '36px'
    }
  },
  listTeaser: {
    frontWeight: 400,
    lineHeight: '26px',
    fontSize: '20px',
    l: {
      lineHeight: '26px',
      fontSize: '20px'
    }
  },
  main: {
    fontWeight: 400,
    lineHeight: '20px',
    fontSize: '18px',
    m: {
      lineHeight: '28px',
      fontSize: '24px'
    }
  },
  subline: {
    fontWeight: 400,
    lineHeight: '18px',
    fontSize: '16px',
    m: {
      lineHeight: '20px',
      fontSize: '18px'
    }
  },
  copy: {
    fontWeight: 300,
    lineHeight: '30px',
    fontSize: '16px'
  },
  copyThick: {
    fontWeight: 700,
    lineHeight: '30px',
    fontSize: '16px'
  },
  copyFocused: {
    fontWeight: 300,
    lineHeight: '28px',
    fontSize: '18px',
    m: {
      lineHeight: '30px',
      fontSize: '19px'
    }
  },
  copySmall: {
    fontWeight: 300,
    lineHeight: '20px',
    fontSize: '14px'
  },
  copySmallThick: {
    lineHeight: '20px',
    fontSize: '14px',
    fontWeight: 700
  },
  copyExtraSmall: {
    fontWeight: 300,
    lineHeight: '16px',
    fontSize: '12px',
    m: {
      lineHeight: '16px',
      fontSize: '12px'
    }
  }
};

const transitions = {
  default: {
    property: 'all',
    duration: 0.4,
    easing: 'ease-in-out',
    delay: null
  },
  defaultFast: {
    property: 'all',
    duration: 0.2,
    easing: 'ease-in-out',
    delay: null
  },
  fadeFast: {
    property: 'opacity',
    duration: 0.2,
    easing: 'ease-in-out',
    delay: null
  },
  anchorLinks: {
    property: 'transform',
    duration: 0.2,
    easing: 'cubic-bezier(.48,0,.5,1)',
    delay: null
  },
  inputError: {
    property: 'opacity',
    duration: 0.2,
    easing: 'ease-in-out',
    delay: null
  }
};

export { breakpoints, colors, fontFamilies, grid, maxWidth, spacings, textTypes, transitions };
